import styled from 'styled-components/macro';

export const DocumentIconLink = styled.span<{
  isActive: boolean;
  onClick?: () => void;
  children?: React.ReactNode;
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2px;
  opacity: ${(p) => p.isActive ? 1.0 : 0.5};
  color: ${(p) => p.theme.palette.textPrimary};
  :hover {
      cursor: pointer;
      background-color: ${(p) => p.theme.palette.backgroundSecondary};
      border-color: ${(p) => p.theme.palette.accentSecondary};
      opacity: 1;
  }
`